export { default } from './GraficArc';
